import React from "react";
import { View, StyleSheet } from "react-native";
import RText from "../../../../RText";
import variables from "../../../../../styles/variables";

import {
  RacecardRes,
  ResultRes,
} from "../../../../../types/races/racecardAndResultWidget";

const { colors } = variables;

/**
 * RacecardAndResultWidgetDescription is a shared component used across
 * the racecard and result widgets
 *
 * It displays the distance, runner count, and grade underneath the header
 *
 * If the component is being used in a result widget, it will display
 * additional "RESULT" text at the start
 *
 * @property {boolean} isResult - Indicates if the widget is a result widget (default: true),
 * otherwise it's a racecard widget
 * @property {object} data - Object containing race information (distance, runner count, grade)
 *
 * @returns {JSX.Element} The RacecardAndResultWidgetDescription component.
 */

type Props = {
  isResult: boolean;
  data: RacecardRes | ResultRes;
};

const RacecardAndResultWidgetDescription = ({ isResult, data }: Props) => {
  const parts = [
    isResult && "RESULT",
    data.distance_formatted,
    data.runner_count_text?.capitalize(),
    isResult ? data.grade : null,
  ].filter(Boolean);

  return (
    <View style={styles.container}>
      {parts.map((text, index) => (
        <RText
          key={text}
          size="xs"
          weight={text === "RESULT" ? "bold" : undefined}
          color={text === "RESULT" ? undefined : "grey"}
        >
          {index > 0 && "  I  "}
          {text}
        </RText>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    borderTopWidth: 1,
    borderBottomWidth: 1,
    borderStyle: "solid",
    borderColor: colors.palette.neutral.x100,
    paddingVertical: 2,
    // marginBottom: 4,
  },
});

export default RacecardAndResultWidgetDescription;
